
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Hinjewaditonavimumbaiinternatinalairportcab() {



const cardData = {
  keyword: "Hinjewadi to Navi Mumbai International Airport Cab",
  heading: "Skyline Cabs: Hinjewadi to Navi Mumbai International Airport Cab",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Hinjewadi to Navi Mumbai International Airport Cab services for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from Hinjewadi Phase 1, Phase 2, Phase 3, or Rajiv Gandhi Infotech Park, we offer smooth expressway connectivity to Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures stress-free airport transfers from Hinjewadi to Navi Mumbai.",

  top: "Top Places Near Navi Mumbai Airport After Arrival",

  topPlaces: [
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is one of the most scenic stretches in Navi Mumbai offering wide lanes, sea views, and smooth connectivity between Vashi, Nerul, and Belapur. Travelers arriving through Hinjewadi to Navi Mumbai International Airport Taxi often enjoy this coastal drive after airport drop. The peaceful environment and organized infrastructure make it ideal for business and residential access. Skyline Cabs ensures comfortable drop coordination along this important corridor."
    },
    {
      title: "Central Park Kharghar",
      description: "Central Park in Kharghar is a well-developed recreational space ideal for relaxation after long airport travel. IT professionals booking Hinjewadi Phase 1 to Navi Mumbai Airport Cab frequently plan short visits here before heading home or hotel. The park offers jogging tracks, gardens, and open spaces perfect for unwinding."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall is a premium shopping and dining hub close to Navi Mumbai Airport. Passengers using Hinjewadi to Navi Mumbai Airport Taxi often stop here for meals or shopping before final drop."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple offers a peaceful spiritual experience with beautiful architecture and hilltop views. Many travelers booking Hinjewadi Phase 2 to Navi Mumbai Airport Taxi include temple visits in their schedule."
    },
    {
      title: "Belapur Business District",
      description: "Belapur is a major corporate zone near Navi Mumbai Airport, hosting offices and commercial establishments. Professionals booking Rajiv Gandhi Infotech Park to Navi Mumbai Airport Cab frequently travel to this area for meetings and business coordination."
    }
  ],

  services: [
    {
      name: "Hinjewadi to Navi Mumbai International Airport Cab",
      description: "Skyline Cabs offers dependable Hinjewadi to Navi Mumbai International Airport Cab service designed for smooth intercity airport transfers. Our vehicles are clean, air-conditioned, and suitable for long expressway travel with sufficient luggage space. Professional chauffeurs are familiar with peak traffic timings around Hinjewadi IT Park and select optimized routes for punctual arrival. Whether you are traveling for international flights or corporate meetings, we ensure structured airport coordination and transparent pricing without hidden charges."
    },
    {
      name: "Hinjewadi to Navi Mumbai International Airport Taxi",
      description: "Hinjewadi to Navi Mumbai International Airport Taxi ensures reliable and comfortable highway travel with professional drivers experienced in Pune–Mumbai connectivity routes. Flexible scheduling allows early morning or late-night airport transfers."
    },
    {
      name: "Hinjewadi to Navi Mumbai International Airport Cabs",
      description: "Hinjewadi to Navi Mumbai International Airport Cabs provide multiple vehicle options including sedan and SUV categories ideal for individual and family airport travel. Our service ensures punctual pickup and safe driving standards."
    },
    {
      name: "Hinjewadi to Navi Mumbai Airport Cab",
      description: "Hinjewadi to Navi Mumbai Airport Cab offers structured airport transfer planning with real-time departure coordination and highway expertise."
    },
    {
      name: "Hinjewadi to Navi Mumbai Airport Taxi",
      description: "Hinjewadi to Navi Mumbai Airport Taxi ensures smooth expressway connectivity with professional chauffeur support and transparent fare breakdown."
    },
    {
      name: "Hinjewadi Phase 1 to Navi Mumbai Airport Cab",
      description: "Hinjewadi Phase 1 to Navi Mumbai Airport Cab provides timely pickup from residential and IT zones with safe and comfortable long-distance travel."
    },
    {
      name: "Hinjewadi Phase 2 to Navi Mumbai Airport Taxi",
      description: "Hinjewadi Phase 2 to Navi Mumbai Airport Taxi ensures reliable airport transfer with experienced drivers familiar with corporate travel requirements."
    },
    {
      name: "Hinjewadi Phase 3 to Navi Mumbai Airport Cab",
      description: "Hinjewadi Phase 3 to Navi Mumbai Airport Cab offers smooth highway connectivity and punctual airport drop coordination."
    },
    {
      name: "Rajiv Gandhi Infotech Park to Navi Mumbai Airport Cab",
      description: "Rajiv Gandhi Infotech Park to Navi Mumbai Airport Cab is specially designed for corporate travelers requiring professional airport transfers with timely arrival and secure travel planning."
    }
  ],

  tableData: [
    ["Hinjewadi to Navi Mumbai International Airport Cab", "Hinjewadi to Navi Mumbai International Airport Taxi"],
    ["Hinjewadi to Navi Mumbai International Airport Cabs", "Hinjewadi to Navi Mumbai Airport Cab"],
    ["Hinjewadi to Navi Mumbai Airport Taxi", "Hinjewadi Phase 1 to Navi Mumbai Airport Cab"],
    ["Hinjewadi Phase 2 to Navi Mumbai Airport Taxi", "Hinjewadi Phase 3 to Navi Mumbai Airport Cab"],
    ["Rajiv Gandhi Infotech Park to Navi Mumbai Airport Cab", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "IT Corridor Pickup Expertise",
      WhyChoosedescription: "Our drivers understand Hinjewadi traffic patterns and IT park entry/exit routes ensuring punctual airport arrival."
    },
    {
      WhyChooseheading: "Expressway Route Experience",
      WhyChoosedescription: "Experienced chauffeurs ensure safe and smooth driving on Pune–Mumbai expressway."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription: "Clear fare breakdown with no hidden charges for airport transfers."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Round-the-clock service for early morning and late-night international flights."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription: "Well-maintained and sanitized cars suitable for long-distance travel."
    },
    {
      WhyChooseheading: "Corporate Travel Friendly",
      WhyChoosedescription: "Ideal for IT professionals and business executives traveling internationally."
    },
    {
      WhyChooseheading: "Flexible Pickup Locations",
      WhyChoosedescription: "Service available from Phase 1, Phase 2, Phase 3, and Rajiv Gandhi Infotech Park."
    },
    {
      WhyChooseheading: "Customer Satisfaction Focus",
      WhyChoosedescription: "Dedicated support team ensures smooth airport coordination and stress-free travel."
    }
  ]
}

const faqData = [
    {
        id: 1,
        question: 'How can I book Hinjewadi to Navi Mumbai International Airport Cab with Skyline Cabs?',
        answer:
            'Booking Hinjewadi to Navi Mumbai International Airport Cab with Skyline Cabs is quick and hassle-free. Simply visit our website or mobile app, enter Hinjewadi as your pickup location and Navi Mumbai International Airport as your drop destination, choose your preferred vehicle, and confirm your ride instantly. You will receive immediate booking confirmation along with driver and vehicle details. Our smooth booking system ensures stress-free airport travel planning, especially for corporate and frequent flyers.',
    },
    {
        id: 2,
        question: 'Is Hinjewadi to Navi Mumbai International Airport Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Hinjewadi to Navi Mumbai International Airport Cab service. Whether your flight is early morning, late night, or during peak hours, our professional drivers ensure punctual pickup from your home, office, or IT park location. We prioritize timely airport transfers so you never miss your flight.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Hinjewadi to Navi Mumbai International Airport Cab?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Hinjewadi to Navi Mumbai International Airport Cab bookings. You can choose economical sedans for budget travel or spacious SUVs for family and corporate group transfers. All vehicles are clean, well-maintained, fully air-conditioned, and driven by experienced chauffeurs.',
    },
    {
        id: 4,
        question: 'How much is the Hinjewadi to Navi Mumbai International Airport Cab fare?',
        answer:
            'The Hinjewadi to Navi Mumbai International Airport Cab fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing policy where the total fare is shown before booking confirmation. The price includes driver allowance and applicable charges, ensuring no hidden fees or last-minute surprises.',
    },
    {
        id: 5,
        question: 'Is one-way Hinjewadi to Navi Mumbai International Airport Cab available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Hinjewadi to Navi Mumbai International Airport Cab service. You only pay for the distance traveled without unnecessary return charges. This makes it convenient and cost-effective for airport drops and single-direction travel.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Hinjewadi to Navi Mumbai International Airport?',
        answer:
            'The journey from Hinjewadi to Navi Mumbai International Airport typically takes around 2.5 to 3.5 hours depending on traffic conditions and time of travel. Our experienced drivers choose the best routes via expressways and highways to ensure smooth and comfortable travel.',
    },
    {
        id: 7,
        question: 'Is online payment available for Hinjewadi to Navi Mumbai International Airport Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments via UPI, credit cards, debit cards, and net banking. Once payment is successfully completed, you receive instant confirmation along with trip and driver details. The process is safe, fast, and convenient.',
    },
    {
        id: 8,
        question: 'Can I pre-book Hinjewadi to Navi Mumbai International Airport Cab?',
        answer:
            'Absolutely. You can pre-book your Hinjewadi to Navi Mumbai International Airport Cab for any future date and time. Advance booking ensures vehicle availability, especially during peak travel seasons, weekends, and corporate travel rush.',
    },
    {
        id: 9,
        question: 'Is Hinjewadi to Navi Mumbai International Airport Cab suitable for corporate travel?',
        answer:
            'Yes, our Hinjewadi to Navi Mumbai International Airport Cab service is highly preferred by corporate professionals working in IT parks and business hubs. We provide punctual pickups, professional chauffeurs, clean premium vehicles, and reliable service for business and executive airport transfers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Hinjewadi to Navi Mumbai International Airport Cab?',
        answer:
            'Skyline Cabs is trusted for Hinjewadi to Navi Mumbai International Airport Cab service because of our professional drivers, sanitized vehicles, transparent pricing, punctual airport transfers, and 24x7 customer support. We focus on delivering safe, comfortable, and reliable long-distance airport travel every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Rohan Kulkarni",
        rating: 5,
        review: "Booked Hinjewadi to Navi Mumbai International Airport Cab with Skyline Cabs for a late-night flight. The driver was punctual, the car was spotless, and the journey was smooth. Highly dependable airport service!"
    },
    {
        name: "Ms. Priya Deshpande",
        rating: 4,
        review: "Very reliable Hinjewadi to Navi Mumbai International Airport Cab service. Transparent pricing and comfortable ride made my airport travel stress-free. Skyline Cabs provides professional service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi to Navi Mumbai International Airport Cab",
  "image": "https://skylinecabs.com/assets/images/hinjewadi-to-navi-mumbai-airport-cab.jpg",
  "description": "Book Hinjewadi to Navi Mumbai International Airport Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, and Sedan cabs available from Hinjewadi Phase 1, 2, 3, Rajiv Gandhi Infotech Park, and Maan Hinjewadi with professional drivers at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2699",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/hinjewadi-to-navi-mumbai-international-airport-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Hinjewadi to Navi Mumbai International Airport Cab | AC Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Hinjewadi to Navi Mumbai International Airport Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, and Sedan cabs available with professional drivers from all Hinjewadi phases." 
  />
  <meta 
    name="keywords" 
    content="Hinjewadi to Navi Mumbai International Airport Cab, Hinjewadi to Navi Mumbai International Airport Taxi, Hinjewadi to Navi Mumbai International Airport Cabs, Hinjewadi to Navi Mumbai Airport Cab, Hinjewadi to Navi Mumbai Airport Taxi, Hinjewadi Phase 1 to Navi Mumbai Airport Cab, Hinjewadi Phase 2 to Navi Mumbai Airport Taxi, Hinjewadi Phase 3 to Navi Mumbai Airport Cab, Rajiv Gandhi Infotech Park to Navi Mumbai Airport Cab, Maan Hinjewadi to Navi Mumbai Airport Taxi, Innova Crysta Hinjewadi to Navi Mumbai Airport, Ertiga Cab Hinjewadi to Navi Mumbai Airport, Sedan Cab Hinjewadi to Navi Mumbai Airport, Skyline Cabs Hinjewadi to Navi Mumbai Airport" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/137.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hinjewaditonavimumbaiinternatinalairportcab;